<template>
    <div>
      <el-dialog
        title="计费合并到户计算"
        :visible.sync="dialogVisible"
        width="1200px"
        class="meter-order-dialog"
        :append-to-body="true"
        :close-on-click-modal="false"
        :before-close="handleClose">
        <el-progress v-if="progress>0" :percentage="progress"></el-progress>
        <div v-if="progress>0">{{progress_msg}}</div>
        <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
<!--          <el-descriptions-item label="项目房产">-->
<!--            {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}-->
<!--          </el-descriptions-item>-->
          <el-descriptions-item label="抄表月份">
            <el-date-picker
              v-model="mainObj.read_month"
              size="mini"
              type="month"
              format="yyyy-MM"
              disabled
              value-format="yyyy-MM"
              placeholder="选择月">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="客户房产">
            <el-autocomplete
              style="min-width: 400px;max-width: 100%"
              size="mini"
              v-model="mainObj.house_name"
              :fetch-suggestions="querySearchAsyncRoom"
              @select="handleSelect"
              placeholder="请输入房产"
              popper-class="autocomplete-room"
              clearable
            ></el-autocomplete>
          </el-descriptions-item>
          <el-descriptions-item label="应收日期">
            <el-date-picker
              v-model="where.should_charge_date"
              size="mini"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              class="setting-data"
              placeholder="选择日期">
            </el-date-picker>
            <br />
            <span style="color: #ff8080;">* 会设置当前条件下的应收日期（必选）</span>
          </el-descriptions-item>
          <el-descriptions-item label-class-name="descriptions-label-class" label="客户名称">
            <el-autocomplete
              class="w-300"
              size="mini"
              v-model="where.customer_name"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入姓名"
              @select="handleSelect2"
            ></el-autocomplete>
          </el-descriptions-item>
          <el-descriptions-item label="合并费项方式">
            <div>
              <el-radio class="setting-data" v-for="item in group_by_list" v-model="where2.group_by" :label="item.val" :key="item.val" size="mini">{{item.name}}</el-radio>
            </div>
            <br />
            <span style="color: #ff8080;">* 合并费项方式（必选），除了“按房产+收费标准”方式，其他方式均需要选择收费项目、收费标准</span>
          </el-descriptions-item>
          <el-descriptions-item label="仪表编号">
            <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="合并物业能耗">
            <div>
              <el-radio class="setting-data" v-for="item in [{name:'否',val:0},{name:'是',val:1}]" v-model="where2.is_wuye_merge" :label="item.val" :key="item.val" size="mini">{{item.name}}</el-radio>
            </div>
            <span style="color: #ff8080;">* 物业能耗是否响应合并（选择合并后，该费项不在显示抄表读数）</span>
          </el-descriptions-item>
          <el-descriptions-item label="仪表名称">
            <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable ></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="计费周期">
            <el-row>
              <el-col :span="12">
                <el-date-picker
                  v-model="where2.startDate"
                  size="mini"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  class="setting-data"
                  placeholder="开始时间">
                </el-date-picker>
              </el-col>
              <el-col :span="12">
                <el-date-picker
                  v-model="where2.endDate"
                  size="mini"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  class="setting-data"
                  placeholder="结束时间">
                </el-date-picker>
              </el-col>
            </el-row>
            <br />
            <span style="color: #ff8080;">* 会设置当前条件下的计费周期（必选）</span>
          </el-descriptions-item>
          <el-descriptions-item label="仪表类型">
            <el-select size="mini" v-model="where.meter_type" clearable filterable placeholder="类型">
              <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="收费项目">
            <el-select class="setting-data" :disabled="where2.group_by===1" size="mini" v-model="where2.chargeItem_name_id" filterable clearable placeholder="收费项目">
              <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <br />
            <span style="color: #ff8080;">* 会设置当前条件下公摊能耗的收费项目，请谨慎选择</span>
          </el-descriptions-item>
          <el-descriptions-item label="能耗类型">
            <el-select size="mini" v-model="where.energy" clearable filterable placeholder="类型">
              <el-option v-for="item in energy_list" :key="item.val" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="收费标准">
            <el-select size="mini" class="setting-data" :disabled="where2.group_by===1" v-model="where2.charging_standard" filterable clearable placeholder="收费标准" >
              <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <br />
            <span style="color: #ff8080;">* 会设置当前条件下公摊能耗的收费标准，请谨慎选择</span>
          </el-descriptions-item>
          <el-descriptions-item label="">

          </el-descriptions-item>
          <el-descriptions-item label="损耗独立">
            <div>
              <el-radio class="setting-data" v-for="item in [{name:'否',val:0},{name:'是',val:1}]" v-model="where2.is_loss_merge" :label="item.val" :key="item.val" size="mini">{{item.name}}</el-radio>
            </div>
            <br />
            <span style="color: #ff8080;">* 独立损耗费用只局限于四级表才独立。</span>
          </el-descriptions-item>
          <el-descriptions-item v-if="!where2.is_loss_merge" label="">

          </el-descriptions-item>
          <el-descriptions-item v-if="where2.is_loss_merge" label="独立损耗设置">
            <el-tag
              :key="tag.id"
              v-for="tag in meter_project_loss_chang_list"
              closable
              :disable-transitions="false"
              @click="openMeterProjectLossChangDialog(tag)"
              @close="removeMeterProjectLossChang(tag.id)" size="mini">
              {{tag.name}}
            </el-tag>
            <el-button size="mini" @click="meter_project_loss_chang_dialog=true">添加损耗收费标准</el-button>
          </el-descriptions-item>
          <el-descriptions-item label="说明">
            <p>左侧为作用操作区域（会按照设置的数据修改某些数据），右侧为查询条件区域（只用筛查数据）。</p>
            <p>【合并费项方式】选择“房产+收费标准”时，会将同一房产、同一收费标准的费用合并为一项，并计算总费用；选择“房产+收费项目”时，会将同一房产、同一收费项目的费用合并为一项，并计算总费用；选择“按房产”时，会将同一房产的所有费用合并为一项，并计算总费用。</p>
            <p>【收费项目】和【收费标准】只修改公共能耗的计费合成，不修改物业能耗和业主能耗的计费合成。</p>
            <p>【应收日期】和【计费周期】会成为当前抄表月份所有能耗的默认数据。</p>
            <p>独立损耗：通常设置了销售价后，不该存在损耗费用，但局部项目需要，所以需要独立出来，项目依据各自实际情况进行设置，请谨慎操作。</p>
          </el-descriptions-item>
        </el-descriptions>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关 闭</el-button>
          <el-button type="primary" @click="computeDosageNumber">计 算</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="添加损耗收费标准"
        :visible.sync="meter_project_loss_chang_dialog"
        width="500px"
        :before-close="handleClose"
        :close-on-click-modal="false">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="费用名称">
            <el-input v-model="meter_project_loss_chang_item.name" placeholder="请输入费用名称"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表类型">
            <el-select v-model="meter_project_loss_chang_item.meter_type" placeholder="请选择费用类型">
              <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="收费项目">
            <el-select v-model="meter_project_loss_chang_item.chargeItem_name_id" placeholder="请选择收费项目" clearable filterable>
              <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="收费标准">
            <el-select v-model="meter_project_loss_chang_item.charging_standard" placeholder="请选择收费标准" clearable filterable>
              <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-descriptions-item>
        </el-descriptions>
        <span slot="footer" class="dialog-footer">
          <el-button @click="meter_project_loss_chang_dialog = false">取 消</el-button>
          <el-button type="primary" @click="addMeterProjectLossChang">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import MeterHttp from "../../../common/MeterHttp";
import {Loading} from "element-ui";
import moment from "moment";

export default {
  name: "MeterOrderHouseComputeDialog",
  inject: ['mainObj','componentId','setComponentId','where'],
  data() {
    return {
      dialogVisible: false,
      apportion_meter_type_list:[{name:"存用量",val:1},{name:"线损",val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      energy_obj:{1:"业主能耗",2:"物业能耗",3:"分摊能耗"},
      meter_type_list: [],
      house_charge_list:[],
      house_charge_item_list:[],
      meter_project_loss_chang_list:[],
      meter_project_loss_chang_item:{
        id:0,
        name:'',
        project_id:0,
        meter_type:0,
        chargeItem_name_id:0,
        charging_standard:0,
      },
      meter_project_loss_chang_dialog:false,
      chargeItem_name_ids:null,
      group_by_list:[{name:"房产+收费标准",val:1},{name:"房产+收费项目",val:2},{name:"按房产",val:3}],
      callback:null,
      where2:{
        group_by:1,
        startDate:moment(this.mainObj.read_month+'-01').format('YYYY-MM-01'),
        endDate:moment(this.mainObj.read_month+'-01').endOf('month').format('YYYY-MM-DD'),
        charging_standard:'',
        chargeItem_name_id:'',
        is_wuye_merge:0,
        is_loss_merge:0,
      },
      progress: 0,
      socket_key:null,
      progress_msg:"",
    };
  },
  created() {
    this.getMeterTypeList();
  },
  methods: {
    show(callback){
      this.getHouseChargeitemNameList();
      this.where2.chargeItem_name_id&&this.getHouseChargeList();
      this.dialogVisible = true;
      this.where2.startDate=moment(this.mainObj.read_month+'-01').format('YYYY-MM-01');
      this.where2.endDate=moment(this.mainObj.read_month+'-01').endOf('month').format('YYYY-MM-DD');
      this.getMeterProjectLossChangList()
      this.callback=callback;
    },
    handleClose() {
      this.dialogVisible = false;
      this.callback=null;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      });
    },
    computeDosageNumber(){
      const that = this;
      let where = ERP.reJson(this.where);
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      let loadingInstance = Loading.service({ fullscreen: true });
      MeterHttp.post("MeterOrderHouse/computeHouse2",{
        project_id:that.mainObj.project_id,
        ...where,
        ...that.where2,
        user_type:(that.$route.query.type||0),
      }, res => {
        loadingInstance.close();
        if (res.code) {
          // that.$message.success('计算成功');

          that.$socket.socket.on('MeterOrderHouseCompute',(data)=>{
            let dataObj = JSON.parse(data.content);
            that.progress = dataObj.progress;
            that.progress_msg = dataObj.msg;
            if(that.progress==100){
              that.socket_key = null;
              that.$message.success('生成成功');
              that.callback&&that.callback(res.data);
              that.$socket.socket.off('MeterOrderHouseCompute');
              that.progress = 0;
            }
          })


          // that.callback&&that.callback(res.data);
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    querySearchAsync(queryString, cb) {
      const that = this;
      if(!queryString){
        cb([])
        return false
      }
      let from_data={}
      from_data.key_name=queryString;
      ERP.getRequest({url:"admin/Customer/getCustomerList",data:from_data},res=>{
        if (res.code) {
          cb(res.data.map(ret=>{return {
            value:`${ret.name}-【${(ret.house_list.map(re=>re.address).join(','))}】`,//
            id:ret.id,
            data:ret
          }}));
        }
      })
    },
    handleSelect2(item) {
      const that = this;
      // that.where.customer_id=item.data.id||0;
      that.where.customer_name=item.data.name;
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      // this.where.house_id=item.id||0;
      this.where.house_name=item.value;
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      this.where2.chargeItem_name_id&&(where.chargeItem_name_ids=(this.where2.chargeItem_name_id+''));
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      });
    },
    getHouseChargeitemNameList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getHouseChargeitemNameList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data;
        }
      });
    },
    getMeterProjectLossChangList(){
      const that = this;
      MeterHttp.post("MeterProjectLossChang/index",{
        project_id:that.mainObj.project_id,
      },ret=>{
        if(ret.code){
          that.meter_project_loss_chang_list=ret.data;
        }
      });
    },
    removeMeterProjectLossChang(id){
      const that = this;
      MeterHttp.post("MeterProjectLossChang/delete",{
        project_id:that.mainObj.project_id,
        id:id,
      },ret=>{
        if(ret.code){
          that.getMeterProjectLossChangList();
        }
      });
    },
    openMeterProjectLossChangDialog(item){
      const that = this;
      that.meter_project_loss_chang_item=item;
      that.meter_project_loss_chang_dialog=true;
    },
    addMeterProjectLossChang(){
      const that = this;
      if(!that.meter_project_loss_chang_item.name){
        that.$message.error('请输入费用名称');
        return false;
      }
      if(!that.meter_project_loss_chang_item.meter_type){
        that.$message.error('请选择费用类型');
        return false;
      }
      if(!that.meter_project_loss_chang_item.chargeItem_name_id){
        that.$message.error('请选择收费项目');
        return false;
      }
      if(!that.meter_project_loss_chang_item.charging_standard){
        that.$message.error('请选择收费标准');
        return false;
      }
      if(!that.meter_project_loss_chang_item.project_id){
        that.meter_project_loss_chang_item.project_id=that.mainObj.project_id;
      }
      if(!that.meter_project_loss_chang_item.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      MeterHttp.post("MeterProjectLossChang/save",that.meter_project_loss_chang_item,ret=>{
        if(ret.code){
          that.meter_project_loss_chang_dialog=true;
          that.getMeterProjectLossChangList()
        }
      });
    },
  },
  watch: {
    'where2.chargeItem_name_id': {
      handler(val, oldVal) {
        this.getHouseChargeList();
      },
      deep: true
    },
    'meter_project_loss_chang_item.chargeItem_name_id':{
      handler(val, oldVal) {
        this.getHouseChargeList();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.meter-order-dialog{

}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderHouseComputeDialog.vue